import type {EntityType} from 'nutshell-graphql-types';

import {colors} from '../colors/colors';
import {AccountIcon} from '../icon/svg/account-icon';
import {CircleWarningIcon} from '../icon/svg/circle-warning-icon';
import {ContactIcon} from '../icon/svg/contact-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ExCircleIcon} from '../icon/svg/ex-circle-icon';
import {LeadIcon} from '../icon/svg/lead-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TickCircleIcon} from '../icon/svg/tick-circle-icon';

type IconDetails = {
    icon: React.ComponentType<any>;
    color: string;
};

export const getIconDetails = (
    entityType?: EntityType | null,
    isIgnored?: boolean | null
): IconDetails => {
    if (isIgnored) {
        return {icon: ExCircleIcon, color: colors.offWhiteMd};
    } else if (entityType) {
        return getEntityIconDetails(entityType);
    }

    // Otherwise means the field needs to be connected
    return {icon: CircleWarningIcon, color: colors.orangeAttention};
};

export const getEntityIconDetails = (entityType: EntityType): IconDetails => {
    switch (entityType) {
        case 'ACCOUNT':
            return {icon: AccountIcon, color: colors.company};
        case 'LEAD':
            return {icon: LeadIcon, color: colors.lead};
        case 'CONTACT':
        default:
            return {icon: ContactIcon, color: colors.person};
    }
};

export const getConnectedIconDetails = () => ({icon: TickCircleIcon, color: colors.green});
